// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.1
//   protoc               v4.23.4
// source: common/common.proto

/* eslint-disable */
import type { FileAttachment } from "./attachment";
import type { Money } from "./money";
import type { User } from "./users";

export const AppViewType = {
  APP_VIEW_TYPE_UNKNOWN: "APP_VIEW_TYPE_UNKNOWN",
  APP_VIEW_TYPE_HUB: "APP_VIEW_TYPE_HUB",
  APP_VIEW_TYPE_DASH: "APP_VIEW_TYPE_DASH",
  APP_VIEW_TYPE_ANALYTICS: "APP_VIEW_TYPE_ANALYTICS",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type AppViewType = typeof AppViewType[keyof typeof AppViewType];

export namespace AppViewType {
  export type APP_VIEW_TYPE_UNKNOWN = typeof AppViewType.APP_VIEW_TYPE_UNKNOWN;
  export type APP_VIEW_TYPE_HUB = typeof AppViewType.APP_VIEW_TYPE_HUB;
  export type APP_VIEW_TYPE_DASH = typeof AppViewType.APP_VIEW_TYPE_DASH;
  export type APP_VIEW_TYPE_ANALYTICS = typeof AppViewType.APP_VIEW_TYPE_ANALYTICS;
  export type UNRECOGNIZED = typeof AppViewType.UNRECOGNIZED;
}

export const AccessType = {
  UNKNOWN_ACCESS_TYPE: "UNKNOWN_ACCESS_TYPE",
  NO_ACCESS: "NO_ACCESS",
  CUSTOMER: "CUSTOMER",
  ADMIN: "ADMIN",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type AccessType = typeof AccessType[keyof typeof AccessType];

export namespace AccessType {
  export type UNKNOWN_ACCESS_TYPE = typeof AccessType.UNKNOWN_ACCESS_TYPE;
  export type NO_ACCESS = typeof AccessType.NO_ACCESS;
  export type CUSTOMER = typeof AccessType.CUSTOMER;
  export type ADMIN = typeof AccessType.ADMIN;
  export type UNRECOGNIZED = typeof AccessType.UNRECOGNIZED;
}

export const Platform = {
  UNKNOWN: "UNKNOWN",
  WEB: "WEB",
  IOS: "IOS",
  ANDROID: "ANDROID",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type Platform = typeof Platform[keyof typeof Platform];

export namespace Platform {
  export type UNKNOWN = typeof Platform.UNKNOWN;
  export type WEB = typeof Platform.WEB;
  export type IOS = typeof Platform.IOS;
  export type ANDROID = typeof Platform.ANDROID;
  export type UNRECOGNIZED = typeof Platform.UNRECOGNIZED;
}

export interface App {
  id: string;
  name: string;
  internalIdentifier: string;
  imageUrl: string;
  icon?: FileAttachment | undefined;
  consumerViewUrlTemplate?: string | undefined;
  adminViewUrlTemplate?: string | undefined;
  analyticsViewUrlTemplate?: string | undefined;
  discoverViewUrlTemplate?: string | undefined;
  description?: string | undefined;
  prodIosBuildId?: string | undefined;
  prodAndroidBuildId?: string | undefined;
  prodWebBuildId?: string | undefined;
  botId: string;
}

export interface AppBuild {
  id: string;
  appId: string;
  checksum: string;
  platform: Platform;
  createdAt: string | undefined;
  updatedAt: string | undefined;
  status: AppBuild_Status;
  fileUrl: string;
  reviewMessage?: string | undefined;
  supportedAppViewTypes: AppViewType[];
}

export const AppBuild_Status = {
  STATUS_UNKNOWN: "STATUS_UNKNOWN",
  STATUS_DRAFT: "STATUS_DRAFT",
  STATUS_PENDING: "STATUS_PENDING",
  STATUS_APPROVED: "STATUS_APPROVED",
  STATUS_REJECTED: "STATUS_REJECTED",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type AppBuild_Status = typeof AppBuild_Status[keyof typeof AppBuild_Status];

export namespace AppBuild_Status {
  export type STATUS_UNKNOWN = typeof AppBuild_Status.STATUS_UNKNOWN;
  export type STATUS_DRAFT = typeof AppBuild_Status.STATUS_DRAFT;
  export type STATUS_PENDING = typeof AppBuild_Status.STATUS_PENDING;
  export type STATUS_APPROVED = typeof AppBuild_Status.STATUS_APPROVED;
  export type STATUS_REJECTED = typeof AppBuild_Status.STATUS_REJECTED;
  export type UNRECOGNIZED = typeof AppBuild_Status.UNRECOGNIZED;
}

export interface Bot {
  id: string;
  /** @deprecated */
  hubRoute: string;
  title: string;
  imageUrl: string;
  createdAt: string | undefined;
  updatedAt: string | undefined;
  isVerified: boolean;
  installedFirstAppAt?: string | undefined;
  whopFourFiveEnabledAt?: string | undefined;
  logo?: FileAttachment | undefined;
  bannerImage?: FileAttachment | undefined;
  route?: string | undefined;
}

export interface NotificationTopic {
  id: string;
}

export interface CfLocation {
  ipAddress?: string | undefined;
  city?: string | undefined;
  country?: string | undefined;
  continent?: string | undefined;
  longitude?: number | undefined;
  latitude?: number | undefined;
  region?: string | undefined;
  regionCode?: string | undefined;
  metroCode?: string | undefined;
  postalCode?: string | undefined;
  timezone?: string | undefined;
}

export interface AccessPass {
  id: string;
  route: string;
  /** @deprecated */
  name: string;
  headline: string;
  imageUrl: string;
  title: string;
  botId: string;
  createdAt: string | undefined;
  updatedAt: string | undefined;
  discardedAt?: string | undefined;
  shortenedDescription?: string | undefined;
  visibility: AccessPass_Visibility;
  discoverableAt?: string | undefined;
  logo?: FileAttachment | undefined;
  bannerImage?: FileAttachment | undefined;
  accessPassType: AccessPass_AccessPassType;
  activeMembersCount: number;
}

export const AccessPass_Visibility = {
  VISIBILITY_UNKNOWN: "VISIBILITY_UNKNOWN",
  VISIBLE: "VISIBLE",
  HIDDEN: "HIDDEN",
  ARCHIVED: "ARCHIVED",
  QUICK_LINK: "QUICK_LINK",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type AccessPass_Visibility = typeof AccessPass_Visibility[keyof typeof AccessPass_Visibility];

export namespace AccessPass_Visibility {
  export type VISIBILITY_UNKNOWN = typeof AccessPass_Visibility.VISIBILITY_UNKNOWN;
  export type VISIBLE = typeof AccessPass_Visibility.VISIBLE;
  export type HIDDEN = typeof AccessPass_Visibility.HIDDEN;
  export type ARCHIVED = typeof AccessPass_Visibility.ARCHIVED;
  export type QUICK_LINK = typeof AccessPass_Visibility.QUICK_LINK;
  export type UNRECOGNIZED = typeof AccessPass_Visibility.UNRECOGNIZED;
}

export const AccessPass_AccessPassType = {
  ACCESS_PASS_TYPE_UNKNOWN: "ACCESS_PASS_TYPE_UNKNOWN",
  REGULAR: "REGULAR",
  APP: "APP",
  EXPERIENCE_UPSELL: "EXPERIENCE_UPSELL",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type AccessPass_AccessPassType = typeof AccessPass_AccessPassType[keyof typeof AccessPass_AccessPassType];

export namespace AccessPass_AccessPassType {
  export type ACCESS_PASS_TYPE_UNKNOWN = typeof AccessPass_AccessPassType.ACCESS_PASS_TYPE_UNKNOWN;
  export type REGULAR = typeof AccessPass_AccessPassType.REGULAR;
  export type APP = typeof AccessPass_AccessPassType.APP;
  export type EXPERIENCE_UPSELL = typeof AccessPass_AccessPassType.EXPERIENCE_UPSELL;
  export type UNRECOGNIZED = typeof AccessPass_AccessPassType.UNRECOGNIZED;
}

export interface Plan {
  id: string;
  baseCurrency: string;
  renewalPrice: Money | undefined;
  initialPrice: Money | undefined;
  initialPriceDue: Money | undefined;
  createdAt: string | undefined;
  updatedAt: string | undefined;
  billingPeriod?: number | undefined;
  trialPeriodDays?: number | undefined;
  expirationDays?: number | undefined;
  unlimitedStock: boolean;
  paymentLinkDescription?: string | undefined;
  releaseMethod: Plan_ReleaseMethod;
  stock?: number | undefined;
  visibility: Plan_Visibility;
  planType: Plan_PlanType;
}

export const Plan_Visibility = {
  VISIBILITY_UNKNOWN: "VISIBILITY_UNKNOWN",
  VISIBLE: "VISIBLE",
  HIDDEN: "HIDDEN",
  ARCHIVED: "ARCHIVED",
  QUICK_LINK: "QUICK_LINK",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type Plan_Visibility = typeof Plan_Visibility[keyof typeof Plan_Visibility];

export namespace Plan_Visibility {
  export type VISIBILITY_UNKNOWN = typeof Plan_Visibility.VISIBILITY_UNKNOWN;
  export type VISIBLE = typeof Plan_Visibility.VISIBLE;
  export type HIDDEN = typeof Plan_Visibility.HIDDEN;
  export type ARCHIVED = typeof Plan_Visibility.ARCHIVED;
  export type QUICK_LINK = typeof Plan_Visibility.QUICK_LINK;
  export type UNRECOGNIZED = typeof Plan_Visibility.UNRECOGNIZED;
}

export const Plan_ReleaseMethod = {
  RELEASE_METHOD_UNKNOWN: "RELEASE_METHOD_UNKNOWN",
  BUY_NOW: "BUY_NOW",
  WAITLIST: "WAITLIST",
  RAFFLE: "RAFFLE",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type Plan_ReleaseMethod = typeof Plan_ReleaseMethod[keyof typeof Plan_ReleaseMethod];

export namespace Plan_ReleaseMethod {
  export type RELEASE_METHOD_UNKNOWN = typeof Plan_ReleaseMethod.RELEASE_METHOD_UNKNOWN;
  export type BUY_NOW = typeof Plan_ReleaseMethod.BUY_NOW;
  export type WAITLIST = typeof Plan_ReleaseMethod.WAITLIST;
  export type RAFFLE = typeof Plan_ReleaseMethod.RAFFLE;
  export type UNRECOGNIZED = typeof Plan_ReleaseMethod.UNRECOGNIZED;
}

export const Plan_PlanType = {
  PLAN_TYPE_UNKNOWN: "PLAN_TYPE_UNKNOWN",
  RENEWAL: "RENEWAL",
  ONE_TIME: "ONE_TIME",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type Plan_PlanType = typeof Plan_PlanType[keyof typeof Plan_PlanType];

export namespace Plan_PlanType {
  export type PLAN_TYPE_UNKNOWN = typeof Plan_PlanType.PLAN_TYPE_UNKNOWN;
  export type RENEWAL = typeof Plan_PlanType.RENEWAL;
  export type ONE_TIME = typeof Plan_PlanType.ONE_TIME;
  export type UNRECOGNIZED = typeof Plan_PlanType.UNRECOGNIZED;
}

export interface Entry {
  id: string;
  status: Entry_EntryStatus;
  userId: string;
  botId: string;
  planId: string;
  accessPassId: string;
  createdAt: string | undefined;
  updatedAt: string | undefined;
  discardedAt?: string | undefined;
}

export const Entry_EntryStatus = {
  ENTRY_STATUS_UNKNOWN: "ENTRY_STATUS_UNKNOWN",
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  DENIED: "DENIED",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type Entry_EntryStatus = typeof Entry_EntryStatus[keyof typeof Entry_EntryStatus];

export namespace Entry_EntryStatus {
  export type ENTRY_STATUS_UNKNOWN = typeof Entry_EntryStatus.ENTRY_STATUS_UNKNOWN;
  export type PENDING = typeof Entry_EntryStatus.PENDING;
  export type APPROVED = typeof Entry_EntryStatus.APPROVED;
  export type DENIED = typeof Entry_EntryStatus.DENIED;
  export type UNRECOGNIZED = typeof Entry_EntryStatus.UNRECOGNIZED;
}

export interface AccessPassMember {
  id: string;
  accessPassId: string;
  userId: string;
  botId: string;
  accessLevel: AccessType;
  createdAt: string | undefined;
  updatedAt:
    | string
    | undefined;
  /** @deprecated */
  orderOld?: number | undefined;
  order?: number | undefined;
}

export interface Member {
  id: string;
  userId: string;
  botId: string;
  accessLevel: AccessType;
  order?: number | undefined;
  createdAt: string | undefined;
  updatedAt: string | undefined;
}

export interface AccessPassExperience {
  id: string;
  accessPassId: string;
  experienceId: string;
  botId: string;
  /** @deprecated */
  isDeleted: boolean;
  createdAt: string | undefined;
  updatedAt: string | undefined;
  discardedAt?: string | undefined;
  upsellType?: AccessPassExperience_UpsellType | undefined;
  upsellPlan?: Plan | undefined;
  order: number;
  sectionId?: string | undefined;
}

export const AccessPassExperience_UpsellType = {
  UPSELL_TYPE_UNKNOWN: "UPSELL_TYPE_UNKNOWN",
  BEFORE_CHECKOUT: "BEFORE_CHECKOUT",
  AFTER_CHECKOUT: "AFTER_CHECKOUT",
  ONLY_IN_WHOP: "ONLY_IN_WHOP",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type AccessPassExperience_UpsellType =
  typeof AccessPassExperience_UpsellType[keyof typeof AccessPassExperience_UpsellType];

export namespace AccessPassExperience_UpsellType {
  export type UPSELL_TYPE_UNKNOWN = typeof AccessPassExperience_UpsellType.UPSELL_TYPE_UNKNOWN;
  export type BEFORE_CHECKOUT = typeof AccessPassExperience_UpsellType.BEFORE_CHECKOUT;
  export type AFTER_CHECKOUT = typeof AccessPassExperience_UpsellType.AFTER_CHECKOUT;
  export type ONLY_IN_WHOP = typeof AccessPassExperience_UpsellType.ONLY_IN_WHOP;
  export type UNRECOGNIZED = typeof AccessPassExperience_UpsellType.UNRECOGNIZED;
}

export interface AccessPassExperienceSection {
  id: string;
  accessPassId: string;
  botId: string;
  title: string;
  createdAt: string | undefined;
  updatedAt: string | undefined;
  discardedAt?: string | undefined;
  order?: number | undefined;
}

export interface BotExperienceSection {
  id: string;
  botId: string;
  title: string;
  createdAt: string | undefined;
  updatedAt: string | undefined;
  discardedAt?: string | undefined;
  order?: number | undefined;
}

export interface Purchase {
  amount: number;
  currencyCode: string;
  userName: string;
  product: AccessPass | undefined;
  createdAt: number;
  id: string;
  releaseMethod: Purchase_ReleaseMethod;
  formattedAmount: string;
}

export const Purchase_ReleaseMethod = {
  UNKNOWN: "UNKNOWN",
  BUY_NOW: "BUY_NOW",
  WAITLIST: "WAITLIST",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type Purchase_ReleaseMethod = typeof Purchase_ReleaseMethod[keyof typeof Purchase_ReleaseMethod];

export namespace Purchase_ReleaseMethod {
  export type UNKNOWN = typeof Purchase_ReleaseMethod.UNKNOWN;
  export type BUY_NOW = typeof Purchase_ReleaseMethod.BUY_NOW;
  export type WAITLIST = typeof Purchase_ReleaseMethod.WAITLIST;
  export type UNRECOGNIZED = typeof Purchase_ReleaseMethod.UNRECOGNIZED;
}

export interface MarketplaceStats {
  totalGmvUsd: number;
  usersCount: number;
}

export interface ConnectedId {
  type: ConnectedId_Type;
  id: string;
  deviceId: string;
}

export const ConnectedId_Type = {
  UNKNOWN: "UNKNOWN",
  ANONYMOUS: "ANONYMOUS",
  USER: "USER",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type ConnectedId_Type = typeof ConnectedId_Type[keyof typeof ConnectedId_Type];

export namespace ConnectedId_Type {
  export type UNKNOWN = typeof ConnectedId_Type.UNKNOWN;
  export type ANONYMOUS = typeof ConnectedId_Type.ANONYMOUS;
  export type USER = typeof ConnectedId_Type.USER;
  export type UNRECOGNIZED = typeof ConnectedId_Type.UNRECOGNIZED;
}

export interface Channel {
  type: Channel_Type;
  id: string;
}

export const Channel_Type = {
  UNKNOWN: "UNKNOWN",
  /** EXPERIENCE - / A channel to which all users of an experience are subscribed, only when vieweing that experience in the UI. The ID is the experience.tag (exp_XXXXX) */
  EXPERIENCE: "EXPERIENCE",
  /** NOTIFICATIONS - / Not used right now. */
  NOTIFICATIONS: "NOTIFICATIONS",
  /** DMS - / A channel to which all users in a dms_feed are subscribed. Id is the dms_feed.external_id (feed_XXXXX) */
  DMS: "DMS",
  /** USER - / A channel to which a single user is subscribed. (Id is the user's id) */
  USER: "USER",
  /** EVERYONE - / A single channel to which all connections are subscribed. (Id is empty) */
  EVERYONE: "EVERYONE",
  /** AUTHENTICATED - / A single channel to which all authenticated users are subscribed. (Id is empty) */
  AUTHENTICATED: "AUTHENTICATED",
  /** ANONYMOUS - / A channel that is created for every anonymous connection. The id is 128bits of random data. */
  ANONYMOUS: "ANONYMOUS",
  /** PUBLIC - / A channel type that can be connected to by anyone without authentication. Allows anything after the `public_` prefix. */
  PUBLIC: "PUBLIC",
  /** ACCESS_PASS - / A channel to which all users of an access pass are subscribed. The ID is the access_pass.tag (pass_XXXX or prod_XXXX) */
  ACCESS_PASS: "ACCESS_PASS",
  /** APP - / A channel that is used by an app to broadcast data to all of its websocket connections. It may look like: app_XXX or app_XXX_exp_XXX or app_XXX_custom_suffix */
  APP: "APP",
  /** BOT - / A channel to which all members with valid access to a bot are subscribed. The ID is the bot.id (biz_XXX) */
  BOT: "BOT",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type Channel_Type = typeof Channel_Type[keyof typeof Channel_Type];

export namespace Channel_Type {
  export type UNKNOWN = typeof Channel_Type.UNKNOWN;
  export type EXPERIENCE = typeof Channel_Type.EXPERIENCE;
  export type NOTIFICATIONS = typeof Channel_Type.NOTIFICATIONS;
  export type DMS = typeof Channel_Type.DMS;
  export type USER = typeof Channel_Type.USER;
  export type EVERYONE = typeof Channel_Type.EVERYONE;
  export type AUTHENTICATED = typeof Channel_Type.AUTHENTICATED;
  export type ANONYMOUS = typeof Channel_Type.ANONYMOUS;
  export type PUBLIC = typeof Channel_Type.PUBLIC;
  export type ACCESS_PASS = typeof Channel_Type.ACCESS_PASS;
  export type APP = typeof Channel_Type.APP;
  export type BOT = typeof Channel_Type.BOT;
  export type UNRECOGNIZED = typeof Channel_Type.UNRECOGNIZED;
}

export interface ChannelSubscriptionState {
  channel: Channel | undefined;
  isSubscribed: boolean;
  wasAlreadySubscribed: boolean;
  disconnectionReason?: ChannelSubscriptionState_DisconnectionReason | undefined;
}

export const ChannelSubscriptionState_DisconnectionReason = {
  UNKNOWN: "UNKNOWN",
  NO_ACCESS: "NO_ACCESS",
  REQUESTED_DISCONNECT: "REQUESTED_DISCONNECT",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type ChannelSubscriptionState_DisconnectionReason =
  typeof ChannelSubscriptionState_DisconnectionReason[keyof typeof ChannelSubscriptionState_DisconnectionReason];

export namespace ChannelSubscriptionState_DisconnectionReason {
  export type UNKNOWN = typeof ChannelSubscriptionState_DisconnectionReason.UNKNOWN;
  export type NO_ACCESS = typeof ChannelSubscriptionState_DisconnectionReason.NO_ACCESS;
  export type REQUESTED_DISCONNECT = typeof ChannelSubscriptionState_DisconnectionReason.REQUESTED_DISCONNECT;
  export type UNRECOGNIZED = typeof ChannelSubscriptionState_DisconnectionReason.UNRECOGNIZED;
}

export interface Reconnect {
}

export interface ReloadClient {
  versionId: string;
  force: boolean;
}

export interface BroadcastRequest {
  channel: Channel | undefined;
  typingIndicator?: TypingIndicator | undefined;
  markAsRead?: MarkAsRead | undefined;
  position?: Position | undefined;
}

export interface Position {
  x: number;
  y: number;
  type: Position_Type;
  url: string;
  message: string;
}

export const Position_Type = {
  UNKNOWN: "UNKNOWN",
  MOUSE: "MOUSE",
  PLAYER: "PLAYER",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type Position_Type = typeof Position_Type[keyof typeof Position_Type];

export namespace Position_Type {
  export type UNKNOWN = typeof Position_Type.UNKNOWN;
  export type MOUSE = typeof Position_Type.MOUSE;
  export type PLAYER = typeof Position_Type.PLAYER;
  export type UNRECOGNIZED = typeof Position_Type.UNRECOGNIZED;
}

export interface TypingIndicator {
  expireAfter: string | undefined;
}

export interface MarkAsRead {
  experienceId?: string | undefined;
  isGlobal: boolean;
  timestamp: string | undefined;
}

export interface BroadcastResponse {
  channel: Channel | undefined;
  fromUserId: string;
  serverForwardedAt: string | undefined;
  typingIndicator?: TypingIndicator | undefined;
  markAsRead?: MarkAsRead | undefined;
  position?: Position | undefined;
}

export interface DiscoveryAccessPassLiveData {
  accessPassId: string;
  last24HoursGmv?: Money | undefined;
  last24HoursAffiliateEarnings?: Money | undefined;
  last24HoursNewUsers?: number | undefined;
  last24HoursAverageTimePerUser?: string | undefined;
  globalWhopRanking?: number | undefined;
  totalPublishedReviewsCount?: number | undefined;
  lastReview?: AccessPassReview | undefined;
  last7DaysPublishedReviewsCount?: number | undefined;
  activeUsersCount?: number | undefined;
  last30DaysNewUsers?: number | undefined;
  accessPassActivityItem?: AccessPassActivityItem | undefined;
}

export interface AccessPassActivityItem {
  id: string;
  createdAt: string | undefined;
  eventType: string;
  user?: User | undefined;
}

export interface AccessPassReview {
  id: string;
  createdAt: string | undefined;
  publishedAt: string | undefined;
}

export interface FeedContentItem {
  id: string;
  eventType: string;
  metadata: { [key: string]: any } | undefined;
  restPath: string;
  createdAt: string | undefined;
  updatedAt: string | undefined;
  appId: string;
  botId: string;
  experienceId: string;
  externalId: string;
  parentExternalId: string;
  userId: string;
  attachments: FileAttachment[];
  gifs: FeedContentItem_GiphyGif[];
}

export interface FeedContentItem_GiphyGif {
  title: string;
  url: string;
  originalUrl: string;
  previewUrl: string;
  width: number;
  height: number;
  slug: string;
}

export interface UserReferralMarketRates {
  previousRates?: UserReferralMarketRate | undefined;
  currentRates?: UserReferralMarketRate | undefined;
}

export interface UserReferralMarketRate {
  percentOfPlatformSpend?: number | undefined;
  percentOfSellerPayment?: number | undefined;
  percentOfContentRewardsCampaignMaker?: number | undefined;
  percentOfContentRewardsEarner?: number | undefined;
}

export interface GoFetchExperienceList {
  accessPassId: string;
}

export interface GoFetchUserExperiences {
  experienceId: string;
}

export interface BusinessActivityEvent {
  eventType: BusinessActivityEvent_EventType;
  user: User | undefined;
  accessPass: AccessPass | undefined;
  description: string;
  createdAt: string | undefined;
}

export const BusinessActivityEvent_EventType = {
  UNKNOWN: "UNKNOWN",
  MEMBER_JOINED: "MEMBER_JOINED",
  NEW_PAYMENT: "NEW_PAYMENT",
  NEW_DISPUTE: "NEW_DISPUTE",
  MEMBER_CANCELED: "MEMBER_CANCELED",
  MEMBER_CHURNED: "MEMBER_CHURNED",
  NEW_MARKETPLACE_SALE: "NEW_MARKETPLACE_SALE",
  NEW_RESOLUTION_CENTER_CASE: "NEW_RESOLUTION_CENTER_CASE",
  NEW_REVIEW: "NEW_REVIEW",
  TEAM_MEMBER_JOINED: "TEAM_MEMBER_JOINED",
  BANNED_USER: "BANNED_USER",
  FAILED_PAYMENT: "FAILED_PAYMENT",
  PAYOUT_REQUESTED: "PAYOUT_REQUESTED",
  PAYOUT_COMPLETED: "PAYOUT_COMPLETED",
  PAYOUT_FAILED: "PAYOUT_FAILED",
  COMPETITION_ALERT: "COMPETITION_ALERT",
  UNRECOGNIZED: "UNRECOGNIZED",
} as const;

export type BusinessActivityEvent_EventType =
  typeof BusinessActivityEvent_EventType[keyof typeof BusinessActivityEvent_EventType];

export namespace BusinessActivityEvent_EventType {
  export type UNKNOWN = typeof BusinessActivityEvent_EventType.UNKNOWN;
  export type MEMBER_JOINED = typeof BusinessActivityEvent_EventType.MEMBER_JOINED;
  export type NEW_PAYMENT = typeof BusinessActivityEvent_EventType.NEW_PAYMENT;
  export type NEW_DISPUTE = typeof BusinessActivityEvent_EventType.NEW_DISPUTE;
  export type MEMBER_CANCELED = typeof BusinessActivityEvent_EventType.MEMBER_CANCELED;
  export type MEMBER_CHURNED = typeof BusinessActivityEvent_EventType.MEMBER_CHURNED;
  export type NEW_MARKETPLACE_SALE = typeof BusinessActivityEvent_EventType.NEW_MARKETPLACE_SALE;
  export type NEW_RESOLUTION_CENTER_CASE = typeof BusinessActivityEvent_EventType.NEW_RESOLUTION_CENTER_CASE;
  export type NEW_REVIEW = typeof BusinessActivityEvent_EventType.NEW_REVIEW;
  export type TEAM_MEMBER_JOINED = typeof BusinessActivityEvent_EventType.TEAM_MEMBER_JOINED;
  export type BANNED_USER = typeof BusinessActivityEvent_EventType.BANNED_USER;
  export type FAILED_PAYMENT = typeof BusinessActivityEvent_EventType.FAILED_PAYMENT;
  export type PAYOUT_REQUESTED = typeof BusinessActivityEvent_EventType.PAYOUT_REQUESTED;
  export type PAYOUT_COMPLETED = typeof BusinessActivityEvent_EventType.PAYOUT_COMPLETED;
  export type PAYOUT_FAILED = typeof BusinessActivityEvent_EventType.PAYOUT_FAILED;
  export type COMPETITION_ALERT = typeof BusinessActivityEvent_EventType.COMPETITION_ALERT;
  export type UNRECOGNIZED = typeof BusinessActivityEvent_EventType.UNRECOGNIZED;
}
